module.exports = __webpack_public_path__ + "img/cnart.e7655a63.png";